import {FC} from 'react';
import {Box, Grid} from '@chakra-ui/react';
import {useT} from '@kcast-fe/core';
import {TBreakpointStyle, useScreenSize} from 'ui-kit';

interface IProps {
  gridTemplate: TBreakpointStyle;
}

const DocumentListHeaderFC: FC<IProps> = ({gridTemplate}) => {
  const {isLessThan768} = useScreenSize();
  const {t} = useT();

  return (
    <Grid
      h={'32px'}
      gap={isLessThan768 ? '6px' : '12px'}
      bg={'{colors.bgMain}'}
      alignItems={'center'}
      borderRadius={'4px'}
      borderTop={'thin solid'}
      borderBottom={'thin solid'}
      borderColor={'{colors.borderDefault}'}
      gridTemplateColumns={gridTemplate}
    >
      <Box />
      <Box>{t('fields.name')}</Box>
      <Box>{t('fields.status')}</Box>
      {!isLessThan768 && (
        <>
          <Box>{t('fields.index')}</Box>
          <Box>{t('fields.created')}</Box>
        </>
      )}
      <Box />
    </Grid>
  );
};

export const DocumentListHeader = DocumentListHeaderFC;
